import { Card, TextStyle } from '@shopify/polaris';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

export type OverviewCardProps = {
  actionText: React.ReactNode;
  detailsText: React.ReactNode;
  onClick(): void;
  text: React.ReactNode;
};

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0.5rem;
  cursor: pointer;
  align-items: center;
`;

const RightContainer = styled.div`
  display: flex;
`;

const SettingsDetailsText = styled.div`
  font-size: 12px;
  margin-right: 4rem;
`;

const DetailsLink = styled.div`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.givzGreen.hex};
  align-self: center;
`;

const OverviewCard: FunctionComponent<OverviewCardProps> = ({
  actionText,
  detailsText,
  onClick,
  text,
}) => {
  return (
    <Card sectioned>
      <ContentContainer onClick={onClick}>
        <TextStyle>{text}</TextStyle>
        <RightContainer>
          <SettingsDetailsText>{detailsText}</SettingsDetailsText>
          <DetailsLink>{actionText}</DetailsLink>
        </RightContainer>
      </ContentContainer>
    </Card>
  );
};

export default OverviewCard;
